import { ContactForm } from '@dreamstack/feature-components/src/contactForm/ContactForm'
import type { FunctionComponent } from 'react'

export const ContactFormBlock: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  return (
    <>
      <ContactForm />
    </>
  )
}
